module.exports = __webpack_public_path__ + "img/footer-white bg.024c70be.png";